
import AttributeDisplayText from '../AttributeDisplayText/AttributeDisplayText';
import { ValueType } from '../../../Utils/Formatters/FormatterTypes';
import {
  IClientAttributeModel,
  IClientBusinessModel,
} from '../../../Types/ClientModelTypes';
import { makeStyles } from 'tss-react/mui';
import EDCaptionedValue from '../../../BaseComponents/CaptionedValue/EDCaptionedValue';

export type AttributeValueSizeType = 'small' | 'medium' | 'large' | 'ownblock';
export type AttributeValueSizeTypeWithAuto = AttributeValueSizeType | 'auto';

interface IProps {
  collection: IClientBusinessModel;
  attribute: IClientAttributeModel;
  value: ValueType;
  label?: string;
  size?: AttributeValueSizeType;
  smallText?: boolean;
  fillContainer?: boolean;
  header?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  hideLabel?: boolean;
  valueNewLine?: boolean;
  noLeftMargin?: boolean;
  topMargin?: boolean;
  testId?: string;
  masked?: boolean;
}

const attributeValueUseStyles = makeStyles()(
  theme =>
    ({
      displayTextDisabled: {
        color: theme.palette.action.disabled,
      },
      displayText: {
        wordBreak: 'break-word',
        marginRight: theme.spacing(1.25),
      },
    } as const)
);

/**
Visar benämningen och värdet för ett attribut
*/
const AttributeValue = (props: IProps) => {
  const { classes, cx } = attributeValueUseStyles();

  return (
    <EDCaptionedValue
      label={props.label ?? props.attribute.DisplayLabel}
      name={props.attribute.AttributeName}
      header={props.header}
      onClick={props.onClick}
      size={props.size}
      fillContainer={props.fillContainer}
      hideLabel={props.hideLabel}
      disabled={props.disabled}
      noLeftMargin={props.noLeftMargin}
      topMargin={props.topMargin}
      smallText={props.smallText}
    >
      <>
        {props.valueNewLine && <br />}
        <AttributeDisplayText
          value={props.value}
          collection={props.collection}
          attributeModel={props.attribute}
          variant={
            props.smallText ? 'caption' : props.header ? 'h6' : undefined
          }
          classes={{
            root: cx(classes.displayText, {
              [classes.displayTextDisabled]: props.disabled,
            }),
          }}
          testId={props.testId}
          masked={props.masked}
        />
      </>
    </EDCaptionedValue>
  );
};

export default AttributeValue;
